import {
    ClickElement,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackCountDropdownClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.SelectTicketOptions,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.TicketCount,
        },
    });
}

async function trackDropdownSelection(productTitle: string, diff: number): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: diff > 0 ? GA4EventName.IncreaseCount : GA4EventName.DecreaseCount,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            product_count_changed: diff,
            product_title: productTitle,
        },
    });
}

export { trackCountDropdownClicked, trackDropdownSelection };
